import { useEffect, useState } from 'react';

export const MOBILE_BREAKPOINT = 768;
export const TABLET_BREAKPOINT = 1024;

export const useViewport = () => {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    // do not check if exists. Browser api checks if function already exists on EventTarget object
    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  return {
    width,
    currentBreakpoint: {
      isMobile: width < MOBILE_BREAKPOINT,
      isDesktop: width > MOBILE_BREAKPOINT && width > TABLET_BREAKPOINT,
      isTablet: width < TABLET_BREAKPOINT && width > MOBILE_BREAKPOINT,
    },
  };
};
